module.exports = __webpack_public_path__ + "img/doctor.5771782c.png";